import { render, staticRenderFns } from "./strate-alarm-param-cabinet.vue?vue&type=template&id=aaa06ca8&scoped=true&"
import script from "./strate-alarm-param-cabinet.vue?vue&type=script&lang=js&"
export * from "./strate-alarm-param-cabinet.vue?vue&type=script&lang=js&"
import style0 from "./strate-alarm-param-cabinet.vue?vue&type=style&index=0&id=aaa06ca8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaa06ca8",
  null
  
)

export default component.exports